import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportBdpGantungPageRoutingModule } from './report-bdp-gantung-routing.module';

import { ReportBdpGantungPage } from './report-bdp-gantung.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportBdpGantungPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [ReportBdpGantungPage]
})
export class ReportBdpGantungPageModule {}
